import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import './style.scss';

function ModalConvertPaper(props) {
  const { showModalConvertPaper, setShowModalConvertPaper, handleConvertPaper } = props;

  const [converterName, setConverterName] = useState('');

  const handleClose = () => setShowModalConvertPaper(false);

  return (
    <Modal
      show={showModalConvertPaper}
      onHide={handleClose}
      centered
      size="sm"
      className="ModalConvertPaper"
      style={{ zIndex: 1040 }}
    >
      <Modal.Header closeButton>
        <div className="w-100 d-flex flex-row justify-content-between">
          <Modal.Title>Chuyển thành hóa đơn giấy</Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="">
          <p>Họ và tên người chuyển đổi</p>

          <input
            className="form-control"
            value={converterName}
            onChange={(e) => setConverterName(e.target.value)}
            onKeyDown={(e) => {
              if (e.key == 'Enter') {
                handleConvertPaper(converterName);
              }
            }}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="align-seft-end">
          <button
            className="btn btn-primary mr-4 px-8"
            onClick={() => handleConvertPaper(converterName)}
          >
            Tiếp tục
          </button>
          <button className="btn btn-secondary px-8" onClick={handleClose}>
            Đóng
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalConvertPaper;
